<template>
  <section>
    <div class="list">
      <div class="tr tr_title">
        <span class="img-preview">Preview</span>
        <span>Destination</span>
        <span>Start Date</span>
        <span>End Date</span>
        <span>Order</span>
      </div>
      <section ref="sortable">
        <div
          v-for="(val,i) in bannersData"
          :key="i + '-' + val.advert_id"
          class="tr">
          <span class="img-preview">
            <img
              :src="val.banner_url"
              alt="banner"
              class="img-banner" />
          </span>
          <span>{{ val.product_name }}</span>
          <span>{{ val.start_time }}</span>
          <span>{{ val.end_time }}</span>
          <span
            
            class="actions">
            <span
              @click="handlerEdit(val)" >
              <font-awesome-icon
                icon="pen"
                class="icon_pen"/>
            </span>
            <!-- <span
              @click="handlerDel(val)" >
              <font-awesome-icon
                icon="trash-alt"
                class="icon_del"/>
            </span> -->
            <span
              v-if="activeTab == '1'"
              @mousedown="handleClick(val)"
              @mouseenter="handleMouseEnter"
              @mouseleave="handleMouseLeave"
            >
              <font-awesome-icon
                icon="grip-lines"
                class="icon_lines"/>
            </span>
          </span>
        </div>
      </section>
      
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {
  getAdvertList,
  orderAdvert
} from '@/api/news'

import Sortable from 'sortablejs'

export default {
  name: 'BannerList',
  mixins: [MixinOptions],
  props: {
    activeTab: {
      type: [Number, String],
      default: '1'
    },
    destination: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      bannersData: [],
      sortable: {},
      id: -1,
    }
  },
  watch: {
    activeTab: {
      handler(val) {
        this.handlerUpdate()
      }
    },
    destination: {
      handler(val) {
        this.handlerUpdate()
      }
    }
  },
  mounted(){
    this.network().getAdvertList()
    let el = this.$refs['sortable']
    this.createSort(el)
  },
  methods: {
    handlerUpdate() {
      this.network().getAdvertList()
    },
    handlerEdit(row) {
      const { advert_id } = row
      this.$router.push({
        path: '/administration/web/content/banner/detail',
        query: {
          id: advert_id
        }
      })
    },

    // handlerDel(row) {
    //   this.$ConfirmBox({
    //     message: `Are you sure to delete this category（ ${row.languages['en-US']} | ${row.languages['zh-HK']} ）?`
    //   }).then(() => {
    //     const { category_id } = row
    //     let params = {
    //       category_id,
    //       action_name: 'delete'
    //     }
    //     this.network().patchNewsCategory(params)
    //   })
    // },
    handleMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.sortable.option('disabled', true)
    },
    handleMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.sortable.option('disabled', false)
    },

    handleClick(val) {
      this.id = val.advert_id
    },

    sortEnd(e) {
      //   console.log(e)
      // 拖拽完成执行
      if(e.oldIndex != e.newIndex){
        let params = {
          advert_id: this.id,
          old_index: e.oldIndex,
          new_index: e.newIndex,
          // action_name: 'order'
        }
        // const advert_id = this.bannersData[e.oldIndex].advert_id
        // const next_advert_id = this.bannersData[e.newIndex].advert_id
        // const params = {
        //   advert_id,
        //   next_advert_id
        // }

        this.network().orderAdvert(params)
      }
    },

    createSort(el){
      this.sortable = new Sortable(el,{
        ghostClass: 'blue',
        disabled: true,
        onEnd: this.sortEnd
      })
    },
    // handlerCategoryUpdate() {
    //   this.network().getNewsCategoriesList({
    //     hideLoading: true
    //   })
    // },
    network(){
      return {
        getAdvertList: async (params = {}) => {
          const { data } = await getAdvertList({
            status: Number(this.activeTab),
            destination: this.destination == 'all'? undefined: this.destination,
            ...params
          })
          const result = data.data.reduce((result, item) => {
            const data = {
              ...item,
              product_name: this.getOptionName('productTypeOptions', item.product_id)
            }
            result.push(data)
            return result
          }, [])

          this.bannersData = result
        },
        orderAdvert: async params => {
          // console.log(this.bannersData, '---last---')
          const { data } = await orderAdvert(params)
          this.network().getAdvertList({
            hideLoading: true
          })
        },



        getNewsCategoriesList: async () => {
          const { data } = await getNewsCategoriesList()
          data.map((item, index) => {
            let { languages = [] } = item
            if(languages instanceof Array) {
              item.languages = {
                'zh-HK': '',
                'en-US': ''
              }
            }
            return item
          })
          this.categoriesData = data
          this.$emit('get-list', this.categoriesData)
        },
        patchNewsCategory: async params => {
          const { data } = await patchNewsCategory(params)
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.network().getNewsCategoriesList({
            hideLoading: true
          })
        },
        getNewsCategoryDetail: async () => {
          const { data } = await getNewsCategoryDetail({
            category_id: this.editCategoryId
          })
          this.editCategoryData = data
          this.categoryDialog = true
        },
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.blue{
  background: #ecf5ff;
}
.form-item{
  padding-bottom: 16px !important;
  span{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292e;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
}
.img-banner {
      width: 150px;
      height: 72px;
  }
.list{
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: white;
    .img-preview {
        display: block;
        width: 170px;
        min-width: 170px;
    }
    .tr_title{
      height: 40px!important;
      font-weight: bold;
      color: #909399;
      background: #f6f8fa;
    }
    .tr{
      padding: 10px;
      height: 92px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: 14px;
      &>span{
        flex: 1;
        text-align: center;
      }
      .actions{
        span{
          margin-right: 20px;
          padding: 5px;
          cursor: pointer;
          &:last-child {
              margin-right: 0;
          }
          .icon_pen{
            color: rgba(3, 102, 214, 1);
          }
          .icon_del{
            color: rgba(203, 36, 49, 1);
          }
          .icon_lines{
            color: rgba(209, 213, 218, 1);
          }
        }
      }
    }
    .tr+.tr{
      border-top: 1px solid #EAECEF;
    }
  }
.dialog-container {
  padding: 15px;
}
</style>
